import * as React from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { AdminLayout } from '@/components/admin/AdminLayout';
import { SubscriptionAnalytics } from '@/components/admin/SubscriptionAnalytics';

export const Route = createFileRoute('/admin/analytics')({
  component: AdminAnalyticsPage,
});

function AdminAnalyticsPage(): React.JSX.Element {
  return (
    <AdminLayout>
      <div className="space-y-6">
        <div>
          <h1 className="text-3xl font-bold tracking-tight">Subscription Analytics</h1>
          <p className="text-muted-foreground mt-2">
            Track revenue, subscription metrics, and business insights
          </p>
        </div>
        <SubscriptionAnalytics />
      </div>
    </AdminLayout>
  );
}
